import JustValidate from 'just-validate';
import IMask from 'imask';
if(document.querySelector('.payment')) {
document.querySelector('.payment__agree').addEventListener('change',(inpt)=>{
		document.querySelector('.payment__submit').disabled = !document.querySelector('.payment__agree').checked
	})
// Инициализация валидации формы
const validation = new JustValidate('.payment', {
  validateBeforeSubmitting: true,
});
const phoneInput = document.querySelector('[name="phone"]');
const bdInput = document.querySelector('[name="bd"]');

// Маска для телефона
IMask(phoneInput, {
  mask: '+{7} (000) 000 00-00',
});
IMask(
  bdInput,
  {
    mask: Date,
    lazy: false
  }
)


validation
  // Валидация имени
  .addField('[name="name"]', [
    {
      rule: 'required',
      errorMessage: 'Введите имя',
    },
    {
      rule: 'minLength',
      value: 2,
      errorMessage: 'Имя должно содержать минимум 2 символа',
    },
    {
      rule: 'maxLength',
      value: 50,
      errorMessage: 'Имя должно содержать максимум 50 символов',
    },
    {
      rule: 'customRegexp',
      value: /^[a-zA-Zа-яА-ЯёЁ\s\-]+$/,
      errorMessage: 'Имя может содержать только буквы, пробелы и дефисы',
    },
  ])
  
  // Валидация телефона
  .addField('[name="phone"]', [
    {
      rule: 'required',
      errorMessage: 'Введите номер телефона',
    },
    {
      rule: 'customRegexp',
      value: /^\+7\s?\(\d{3}\)\s?\d{3}\s?\d{2}-\d{2}$/,
      errorMessage: 'Формат: +7 (000) 000 00-00',
    },
  ])
  
  // Валидация даты рождения
  .addField('[name="bd"]', [
    {
      rule: 'required',
      errorMessage: 'Введите дату рождения',
    },
    {
      rule: 'customRegexp',
      value: /^\d{2}\.\d{2}\.\d{4}$/,
      errorMessage: 'Формат: ДД.ММ.ГГГГ',
    },
    {
      validator: (value) => {
        const [day, month, year] = value.split('.');
        const date = new Date(year, month - 1, day);
        const today = new Date();
        const minDate = new Date();
        minDate.setFullYear(today.getFullYear() - 100);
        
        return date <= today && date >= minDate;
      },
      errorMessage: 'Введите корректную дату рождения',
    },
  ])
  
  // Валидация email
  .addField('[name="email"]', [
    {
      rule: 'required',
      errorMessage: 'Введите email',
    },
    {
      rule: 'email',
      errorMessage: 'Введите корректный email',
    },
  ])
  
  // Валидация согласия
  .addField('[name="agree"]', [
    {
      rule: 'required',
      errorMessage: 'Необходимо согласие с условиями',
    },
  ])
  
  // Обработка успешной валидации
  .onSuccess((event) => {
    const form = event.target;
    
    // Получаем данные формы
    const formData = new FormData(form);
    
    // Можно добавить дополнительную обработку данных
    console.log('Данные формы:', {
      name: formData.get('name'),
      phone: formData.get('phone'),
      bd: formData.get('bd'),
      email: formData.get('email'),
      payment: formData.get('payment'),
    });
    
    
    // Отправляем форму
    form.submit();
    
    // В реальном проекте лучше использовать fetch для AJAX отправки:
    /*
    fetch(form.action, {
      method: form.method,
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      // Обработка успешной отправки
      console.log('Форма успешно отправлена', data);
    })
    .catch(error => {
      // Обработка ошибки
      console.error('Ошибка отправки формы', error);
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
    });
    */
  })
  
  // Обработка ошибок валидации
  .onFail((fields) => {
    console.log('Ошибки валидации:', fields);
  });
}